var _circle, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fillOpacity: 0,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7.5,
    x2: 16,
    y2: 7.5,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 10.5,
    x2: 14,
    y2: 10.5,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13.5,
    x2: 12,
    y2: 13.5,
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.6e6c7790a6c002d9146cec89974b46bd.svg";